import type { FeatureKey } from "./features";
import type { NavGroup } from "./navigation";
import type { Permission } from "./statement";

/** Where a screen appears: sidebar rail or settings hub section. `hidden` has a route but no
 * sidebar row (Call Logs, Bulk Operations). */
type NavSurface = "sidebar" | "settings" | "hidden";

/** Whose setting a hub screen is. `shared`: the building's list, where a row with no building is
    every building's. `inherited`: the organization's default, which a building may override. */
export type SettingsScope =
  | "organization"
  | "facility"
  | "shared"
  | "inherited"
  | "personal"
  | "platform";

export interface NavItem {
  id: FeatureKey;
  label: string;
  /** The apps/web route; `policy.test.ts` checks each against the route tree. */
  path: string;
  group: NavGroup;
  permission: Permission;
  /** Configuration lives in the settings hub, operations in the sidebar; moving a screen changes
   * where people learned to look. */
  surface?: NavSurface;
  settingsCategory?: string;
  /** Every settings screen names one (`navigation-settings-scope.test.ts` holds it). */
  scope?: SettingsScope;
  platformOnly?: boolean;
}

export const item = (
  id: FeatureKey,
  label: string,
  path: string,
  group: NavGroup,
  permission: Permission,
  extra: Partial<NavItem> = {},
): NavItem => ({ id, label, path, group, permission, ...extra });
